import { Card } from '@digdir/designsystemet-react';

import styled from '../../../styled';

export const TintedCard = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-4);
  background: var(--ds-color-surface-tinted);
  border-radius: var(--ds-border-radius-md);
`;

export const TilstandCard = styled(Card)`
  display: flex;
  flex-direction: row;
  gap: var(--ds-size-4);
  border-radius: var(--ds-border-radius-md);
  align-items: center;
`;

export const CardHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--ds-size-4);
  flex-grow: 1;
  margin-bottom: var(--ds-size-4);
`;

export const Actions = styled.div`
  display: flex;
  gap: var(--ds-size-4);
`;
